"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AICentral = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class AICentral extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.AI_CENTRAL,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING],
            cost: 21,
            productionBox: Units_1.Units.of({ energy: -1 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.SCIENCE, 3)),
            metadata: {
                description: {
                    text: 'Requires 3 Science tags to play. Decrease your Energy production 1 step.',
                    align: 'left',
                },
                cardNumber: '208',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Draw 2 cards.', (ab) => ab.empty().startAction.cards(2)).br;
                    b.production((pb) => pb.minus().energy(1));
                }),
                victoryPoints: 1,
            },
        });
    }
    canPlay(player) {
        return super.canPlay(player) && player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        return undefined;
    }
    canAct() {
        return true;
    }
    getVictoryPoints() {
        return 1;
    }
    action(player) {
        player.drawCard(2);
        return undefined;
    }
}
exports.AICentral = AICentral;
//# sourceMappingURL=AICentral.js.map